class PredictiveSearch extends HTMLElement {
  constructor() {
    super(),
      (this.current_width = window.innerWidth),
      (this.input = this.querySelector(".search--textbox")),
      (this.link_selector = `a[href='${theme.urls.search}']`),
      (this.loading = this.querySelector(".search--loading")),
      (this.results = this.querySelector(".search--results")),
      (this.search_trigger = document.querySelector(
        '[data-trigger="search-modal"]'
      )),
      (this.types =
        "product," +
        ("true" === this.getAttribute("data-show-articles") ? "article," : "") +
        ("true" === this.getAttribute("data-show-collections")
          ? "collection,"
          : "") +
        ("true" === this.getAttribute("data-show-pages") ? "page" : "")),
      this.updateLinks(),
      this.updateLinksListener(),
      this.listenForKeyEntered();
  }
  updateLinks() {
    (this.links = {
      main: theme.off_canvas.main_content.querySelectorAll(this.link_selector),
      right: theme.off_canvas.right_sidebar.querySelectorAll(
        this.link_selector
      ),
      left: theme.off_canvas.left_sidebar.querySelectorAll(this.link_selector),
    }),
      this.searchLinkListeners();
  }
  searchLinkListeners() {
    for (const t in this.links)
      this.links[t].length &&
        (this.links[t].off("click"),
        this.links[t].on("click", (e) => {
          "left" === t
            ? theme.off_canvas.closeLeft()
            : "right" === t && theme.off_canvas.closeRight(),
            setTimeout(() => this.openModal(), "main" === t ? 0 : 450),
            e.preventDefault(),
            e.stopPropagation();
        }));
  }
  openModal() {
    this.search_trigger.click(), window.scrollTo(0, 0), this.input.focus();
  }
  updateLinksListener() {
    window.on("theme:search:updateLinks", () => this.updateLinks());
  }
  listenForKeyEntered() {
    this.input.on("input", () => {
      var e = this.input.value.trim();
      if (!e.length)
        return (
          this.show(!1),
          void (this.abort_controller && this.abort_controller.abort())
        );
      this.getSearchResults(e);
    });
  }
  async getSearchResults(e) {
    (this.loading.style.display = "block"),
      this.abort_controller && this.abort_controller.abort(),
      (this.abort_controller = new AbortController());
    try {
      const r = await fetch(
        `${theme.urls.search}/suggest?q=${e}&resources[type]=${this.types}&resources[limit]=12&section_id=predictive-search`,
        { signal: this.abort_controller.signal }
      );
      if (!r.ok) throw (this.show(!1), new Error(r.status));
      var t = await r.text(),
        i = theme.utils.parseHtml(t);
      (this.results.innerHTML = i.innerHTML),
        this.refineLinkListener(),
        this.matchProductHeights(),
        theme.settings.hover_image_enabled && this.loadHoverImages(),
        this.show(!0);
    } catch {}
  }
  matchProductHeights() {
    const e = this.querySelector(".predictive-search--left");
    theme.utils.matchImageHeights(
      e,
      e.querySelectorAll(".product--root"),
      ".product--image-wrapper"
    ),
      this.resizeProductListener();
  }
  loadHoverImages() {
    this.querySelectorAll(".product--hover-image").forEach((t) => {
      theme.utils.imagesLoaded(t, () => {
        const e = t.closest('[data-hover-image="true"]');
        e && e.setAttribute("data-hover-image", "loaded");
      });
    });
  }
  refineLinkListener() {
    this.querySelectorAll(".predictive-search--refine").on("click", (e) => {
      e = e.target.getAttribute("data-url");
      e === "" + location.pathname + location.search
        ? (window.trigger("theme:modal:close"),
          setTimeout(
            () =>
              document
                .querySelector('[data-toggle-menu="refine-filter"]')
                .click(),
            250
          ))
        : (location.href = e + "#filter--open");
    });
  }
  resizeProductListener() {
    window.off("resize.Search"),
      window.on(
        "resize.Search",
        theme.utils.debounce(100, () => {
          this.current_width !== window.innerWidth &&
            (this.matchProductHeights(),
            (this.current_width = window.innerWidth));
        })
      );
  }
  show(e) {
    (this.results.style.opacity = e ? "1" : "0"),
      (this.loading.style.display = "none");
  }
}
customElements.define("predictive-search-root", PredictiveSearch);
